export class ModelBase{
  public id? : number;
}
